import { $el, getStrTypeAttr, setHtml, removeAttrs } from '../../dom-utils';
import PREFIX from '../prefix';
import DefaultImage from '../../../assets/empty.svg';
var Empty = /** @class */ (function () {
    function Empty() {
        this.VERSION = 'v1.0';
        this.COMPONENTS = $el('r-empty', { all: true });
        this._create(this.COMPONENTS);
    }
    Empty.prototype._create = function (COMPONENTS) {
        var _this = this;
        COMPONENTS.forEach(function (node) {
            var _a = _this._attrs(node), desc = _a.desc, image = _a.image, imageStyle = _a.imageStyle;
            var footerElm = node.firstElementChild;
            _this._setMainTemplate(node, desc, image, imageStyle);
            _this._setFooter(node, footerElm);
            removeAttrs(node, ['desc', 'image', 'image-style']);
        });
    };
    Empty.prototype._setMainTemplate = function (node, desc, image, imageStyle) {
        var template = " \n         <div class=\"" + PREFIX.empty + "-image\" style=\"" + imageStyle + "\">\n            <img src=\"" + image + "\" alt=\"empty\" />\n         </div>\n         <div class=\"" + PREFIX.empty + "-description\">" + (desc == 'false' ? '' : desc) + "</div>";
        setHtml(node, template);
    };
    Empty.prototype._setFooter = function (node, footerElm) {
        if (!footerElm)
            return;
        var footerTpl = "<div class=\"" + PREFIX.empty + "-footer\"></div>";
        node.insertAdjacentHTML('beforeend', footerTpl);
        // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
        node.querySelector("." + PREFIX.empty + "-footer").appendChild(footerElm);
    };
    Empty.prototype._attrs = function (node) {
        return {
            desc: getStrTypeAttr(node, 'desc', '暂无数据'),
            image: getStrTypeAttr(node, 'image', "" + DefaultImage),
            imageStyle: getStrTypeAttr(node, 'image-style', '')
        };
    };
    return Empty;
}());
export default Empty;
